import { displayName } from '@/utils';

export default {
  data() {
    return {
      navigationGroup: null,
      navigationItems: null,
      navigationItem: null,
    };
  },
  mounted() {
    if (this.config?.navigationGroupId) {
      this.navigationGroup = this.$store.getters['navigationGroups/navigationGroups'][this.config.navigationGroupId];
      let items = this.navigationGroup?.navigationItems(this.$store);
      // Hide some navigation items based on user attributes
      const user = this.$store.getters['user/get'];
      const catalogDestinations = ['catalog', 'catalog_page'];
      if (user) {
        if (user.bannedFromDiscussions || !user.catalogPricingEnabled) {
          items = items.filter(navigationItem => {
            // If they are banned from discussions, don't display discussions destinations
            if (user.bannedFromDiscussions && navigationItem.destination === 'discussions') {
              return false;
            }
            // If they are not catalog pricing enabled, don't show catalog destinations
            if (!user.catalogPricingEnabled && catalogDestinations.includes(navigationItem.destination)) {
              return false;
            }
            // Otherwise let them all through
            return true;
          });
        }
      }
      this.navigationItems = items;
      this.navigationItem = this.navigationItems?.[0];
    }
  },
  computed: {
    categoryType() {
      if (this.navigationItem) {
        return this.$store.getters['categoryTypes/categoryTypes'].find(ct => ct.id === this.navigationItem.resourceId);
      }
    },
    widgetIcon() {
      if (this.config) {
        return this.$store.getters['attachments/get'][this.config.iconAttachmentId];
      }
    },
    freeItemsCount() {
      if (this.navigationItem) {
        return this.navigationGroup.accessibleItemsCount(this.$store, this.$access);
      }
    },
    showFreeCounts() {
      if (this.navigationGroup) {
        return this.navigationGroup.showFreeLabel(this.$store, this.$access);
      }
    },
    totalDisplayName() {
      return displayName(this.totalItemsCount);
    },
    totalItemsCount() {
      if (this.navigationGroup) {
        return this.navigationGroup.totalItemsCount(this.$store);
      }
    },
  },
};
